// This hook now uses the Context to avoid multiple instances
import { useItemCountsContext } from '@/contexts/ItemCountsContext';

export const useItemCounts = () => {
  // Simply return the context values - all components share the same state
  return useItemCountsContext();
};
